module.exports = __webpack_public_path__ + "img/Ido_Golding.35364c52.png";